module.exports = {"elasticsearchHost":"wma-elasticsearch.staging.flightstats.io:9200","usersHost":"https://users.iad.staging.flightstats.io","sentry":"https://e19b27bed81840bd84da9cc1b816823f:090769cce1e64838911824e685b73560@sentry.io/148031","billingHost":"https://wma-k8s.iad.staging.flightstats.io/wma-billing/api","flightAlertsHost":"https://wma-k8s.iad.staging.flightstats.io/wma-flight-alerts/api","dataExportsHost":"https://wma-k8s.iad.staging.flightstats.io/wma-data-exports/api","redisHost":"wma-web-staging-001.huxzox.0001.use1.cache.amazonaws.com","redisPort":6379}


//////////////////
// WEBPACK FOOTER
// ./config/config-staging.json
// module id = 3123
// module chunks = 1